'use client';

import useRedirect from '@src/hooks/useRedirect';
import { useParams } from 'next/navigation';

const useRedirectExtend = () => {
  const redirect = useRedirect();
  const { companySlug } = useParams();

  const handleRedirect = (url) => {
    redirect(`/office/${companySlug}/${url}`)
  }

  return handleRedirect
}

export default useRedirectExtend
